export default {
  "months": {
    "long": [
      "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ],
    "short": [
      "ene.", "feb.", "mar.", "abr.", "may.", "jun.",
      "jul.", "ago.", "sep.", "oct.", "nov.", "dic."
    ]
  },
  "weekdays": {
    "long": [
      "Lunes", "Martes", "Miércoles",
      "Jueves", "Viernes", "Sábado", "Domingo"
    ],
    "short": [
      "lun.", "mar.", "mié.", "jue.", "vie.", "sáb.", "dom."
    ]
  },
  "buttons": {
    "today": "Hoy",
    "cancel": "Cancelar",
    "select": "Seleccionar"
  }
};
